import { Component, computed, inject, input, signal } from '@angular/core';
import { PaginatorModule, PaginatorState } from 'primeng/paginator';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PaginationService } from './pagination.service';

@Component({
    selector: 'app-pagination',
    standalone: true,
    imports: [CommonModule, PaginatorModule],
    templateUrl: './pagination.component.html',
    providers: [PaginationService]
})
export class PaginationComponent {

    paginationService = inject(PaginationService);
    router = inject(Router);

    totalRecords = input<number>(0);
    prefix = input<string | null>(null);
    rowsPerPageOptions = this.paginationService.rowsPerPageOptions;

    rows = computed(() =>
        this.prefix()
            ? this.paginationService.getRows(this.prefix()!)()
            : this.paginationService.rows()
    );

    currentPage = computed(() =>
        this.prefix()
            ? this.paginationService.getCurrentPage(this.prefix()!)()
            : this.paginationService.currentPage()
    );

    first = computed(() => {
        return (this.currentPage() - 1) * this.rows();
    });

    onPageChange(event: PaginatorState) {
        const rows = event.rows ?? this.rows();

        const page =
            event.rows !== this.rows()
                ? 1
                // ? this.currentPage()
                : (event.page ?? 0) + 1;

        const queryParams = this.prefix()
            ? {
                [`${this.prefix()}_page`]: page,
                [`${this.prefix()}_per_page`]: rows,
            }
            : {
                page,
                per_page: rows,
            };

        this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge',
        });
    }
}


